import { type TypedUseSelectorHook, useSelector } from "react-redux";
import type { AppState } from "@/store";
import isEqual from "lodash.isequal";

const useAppSelector: TypedUseSelectorHook<AppState> = (selector, equalityFn = isEqual) =>
  useSelector(selector, equalityFn);

export default useAppSelector;
